<template>
  <span>
    <vs-button class="w-full" type="border" color="secondary" @click="showPopup = true">{{ label }}</vs-button>
    <popup-risk-assessment-d-b v-model="showPopup" :max-item-count="maxItemCount" @select="onSelect"/>
  </span>
</template>

<script>
import PopupRiskAssessmentDB from "@/views/boards/single-page/830/PopupRiskAssessmentDB.vue";

export default {
  name: "SelectRiskAssessmentDbButton",
  components: {PopupRiskAssessmentDB},
  props:{
    label: {
      type: String,
      default: "위험성평가 D/B 불러오기"
    },
    maxItemCount: {
      type: Number,
      default: 0, // 0일 경우, 제한 없음
    },
  },
  computed: {
    model: {
      get () {
        return this.value;
      },
      set (val) {
        if (val) {
          this.$emit('input', {
            id: val.id,
            대분류: val.body.사업장,
            중분류: val.body.팀명,
            소분류: val.body.공정명,
            위험구분: val.body.대분류,
            원인: val.body.중분류,
            위험요인: val.body.소분류,
            현재관리상태: val.body.소분류,
            빈도: val.body.소분류,
            강도: val.body.소분류,
            종합: val.body.소분류,
            감소대책: val.body.소분류,
          });
          return;
        }
        this.$emit('input', val);
      }
    }
  },
  data () {
    return {
      showPopup: false
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
    }
  }
}
</script>

<style scoped>

</style>
